import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import installer from './as-needed';
import '@/assets/css/tzsy.css'
import '@/assets/css/messagebox.scss'
import '@/assets/css/tzsy.iconfont.css'

const app = createApp(App)
// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
const pinia = createPinia()
app.use(pinia)
app.use(ElementPlus, {
  locale: zhCn,
})
app.use(router);
app.use(installer);
app.mount('#app');
